import {default as OneSignalPlugin, LogLevel} from "onesignal-cordova-plugin";
import {Injectable} from "@angular/core";

@Injectable()
export class Debug {
  setLogLevel(logLevel: LogLevel): void {
    OneSignalPlugin.Debug.setLogLevel(logLevel);
  }

  setAlertLevel(visualLogLevel: LogLevel): void {
    OneSignalPlugin.Debug.setAlertLevel(visualLogLevel);
  }
}
